module.exports = __webpack_public_path__ + "static/media/P1010232a.7cfc8262.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/explore/akopan/P1010232a.JPG
// module id = 32
// module chunks = 0